import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import Grid2 from "@mui/material/Unstable_Grid2";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { clearError, reset } from "../../teacher/correction/correction.slice";
import ModerationEssayList from "./essay-list.component";
import ModerationEssayDetail from "./essay-detail.component";
import BaseCorrection from "../../teacher/correction/base-correction.component";
import {
  cleanCriteriaValues,
  finishDuplicate,
  finishEdit,
  getEssaysPendingModeration,
} from "../moderator.slice";

export default function Moderation() {
  const moderationState = useAppSelector((state) => state.moderation);
  const dispatch = useAppDispatch();
  const [selectedCorrection, setSelectedCorrection] = useState<number>();

  useEffect(() => {
    if (moderationState.error) {
      const swal = withReactContent(Swal);
      swal
        .fire({
          title: "Ops...",
          text: moderationState.error,
          icon: "error",
          confirmButtonText: "Ok",
        })
        .then(() => dispatch(clearError()));
    }
  }, [moderationState.error]);

  return (
    <Grid2 container margin={3} sx={{ height: "100%" }}>
      <Grid2 xs={3} sx={{ boxShadow: 1 }}>
        <ModerationEssayList />
      </Grid2>
      <Grid2 xs={9}>
        {moderationState.selectedEssay && (
          <ModerationEssayDetail onCorrectionSelected={setSelectedCorrection} />
        )}
      </Grid2>
      <Grid2 xs={12} sx={{ marginTop: "2em", padding: 0 }}>
        {selectedCorrection && (
          <BaseCorrection
            id={selectedCorrection}
            origin="Moderation"
            readonly={true}
            onFinish={() => {
              dispatch(finishDuplicate());
              dispatch(finishEdit());
              dispatch(reset());
              dispatch(getEssaysPendingModeration());
              dispatch(cleanCriteriaValues());
            }}
          />
        )}
      </Grid2>
    </Grid2>
  );
}
